export type LockReason = 'limit' | 'scan_required' | 'scan_screen';

/**
 * Translation keys of the fan page's lock screen. A screen tag is joined from
 * the rotating QR on a stadium screen OR from its fixed printed QR, so its
 * copy names both and no longer says a photo will fail (a photo of the
 * printed sign works). New keys rather than new text on the old ones: an
 * English row already in core_translations would shadow the new text.
 */
export function lockCopyKeys(reason: LockReason): { title: string; message: string } {
  switch (reason) {
    case 'scan_screen':
      return { title: 'error.scanTagTitle', message: 'error.scanTagMessage' };
    case 'scan_required':
      return { title: 'error.reScanRequiredTitle', message: 'error.reScanRequiredMessage' };
    default:
      return { title: 'error.securityLimitTitle', message: 'error.securityLimitMessage' };
  }
}
